import React from 'react';
import './User.css'

function User() {
  return (
    <div>
      <h3>User</h3>
    </div>
  )
}

export default User
